<template>
    <div class="categoriesMenuBlock">
        <div class="product-category-content-wrapper">
            <div class="row" v-if="categoriesLoaded">
                <div class="col-lg-12 dis-flex mb-4 p-lr-0-sm element-forms-selecting desctop-options-menu">
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'fullStructure'" :class="{'active-btn': selectedMenu == 'fullStructure'}">
                        <i class="uis uis-align-alt mr-2"></i>Structure
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createCategory'" :class="{'active-btn': selectedMenu == 'createCategory'}">
                        <i class="uis uis-bars mr-2"></i>category
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createSubCategory'" :class="{'active-btn': selectedMenu == 'createSubCategory'}">
                        <i class="uis uis-align-left mr-2"></i>subcategory
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createSection'" :class="{'active-btn': selectedMenu == 'createSection'}">
                        <i class="uis uis-sort-amount-down mr-2"></i>section
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createSubSection'" :class="{'active-btn': selectedMenu == 'createSubSection'}">
                        <i class="uis uis-list-ui-alt mr-2"></i>subsection
                    </button>
                </div>
                <div class="col-lg-12 mb-4 p-lr-0-sm element-forms-selecting mobile-options-menu">
                    <button type="button" class="btn btn-element" attr="Structure" @click="selectedMenu = 'fullStructure'" :class="{'active-btn': selectedMenu == 'fullStructure'}">
                        <i class="uis uis-align-alt mr-2"></i>
                    </button>
                    <button type="button" class="btn btn-element" attr="category" @click="selectedMenu = 'createCategory'" :class="{'active-btn': selectedMenu == 'createCategory'}">
                        <i class="uis uis-bars mr-2"></i>
                    </button>
                    <button type="button" class="btn btn-element" attr="subcategory" @click="selectedMenu = 'createSubCategory'" :class="{'active-btn': selectedMenu == 'createSubCategory'}">
                        <i class="uis uis-align-left"></i>
                    </button>
                    <button type="button" class="btn btn-element" attr="section" @click="selectedMenu = 'createSection'" :class="{'active-btn': selectedMenu == 'createSection'}">
                        <i class="uis uis-sort-amount-down"></i>
                    </button>
                    <button type="button" class="btn btn-element" attr="subsection" @click="selectedMenu = 'createSubSection'" :class="{'active-btn': selectedMenu == 'createSubSection'}">
                        <i class="uis uis-list-ui-alt"></i>
                    </button>
                </div>
            </div>

            <div class="row for-loading-skeleton" v-else>
                <div class="col-lg-12 mb-4 p-lr-0-sm element-forms-selecting desctop-options-menu dis-flex flex-m flex-w">
                    <button type="button" class="btn skeleton-menu btn-element active-btn">
                        <div class="skeleton skeleton-icon mr-2"></div>
                         <div class="skeleton skeleton-title w-full"></div>
                    </button>
                    <button type="button" class="btn skeleton-menu btn-element">
                        <div class="skeleton skeleton-icon mr-2"></div>
                         <div class="skeleton skeleton-title category-text w-full"></div>
                    </button>
                    <button type="button" class="btn skeleton-menu btn-element">
                        <div class="skeleton skeleton-icon mr-2"></div>
                         <div class="skeleton skeleton-title sub-cat-text w-full"></div>
                    </button>
                    <button type="button" class="btn skeleton-menu btn-element">
                        <div class="skeleton skeleton-icon mr-2"></div>
                         <div class="skeleton skeleton-title section-text w-full"></div>
                    </button>
                    <button type="button" class="btn skeleton-menu btn-element">
                        <div class="skeleton skeleton-icon mr-2"></div>
                         <div class="skeleton skeleton-title sub-section-text w-full"></div>
                    </button>
                </div>
                <div class="col-lg-12 mb-4 p-lr-0-sm element-forms-selecting mobile-options-menu flex-m">
                    <button type="button" class="btn skeleton-menu btn-element active-btn">
                        <div class="skeleton skeleton-icon mr-2"></div>
                         <div class="skeleton skeleton-title w-full"></div>
                    </button>
                    <button type="button" class="btn skeleton-menu btn-element">
                        <div class="skeleton skeleton-icon mr-2"></div>
                    </button>
                    <button type="button" class="btn skeleton-menu btn-element">
                        <div class="skeleton skeleton-icon"></div>
                    </button>
                    <button type="button" class="btn skeleton-menu btn-element">
                        <div class="skeleton skeleton-icon"></div>
                    </button>
                    <button type="button" class="btn skeleton-menu btn-element">
                        <div class="skeleton skeleton-icon"></div>
                    </button>
                </div>
            </div>
            
            <!-- <sell-logix-loader v-if="!categoriesLoaded" :loaderClass="'size-medium'"></sell-logix-loader> -->
            <full-structure v-if="selectedMenu == 'fullStructure'"
                @setSelectedMenu="setSelectedMenu"
                :categoriesLoaded="categoriesLoaded"
                :categoriesList="categoriesList"
                @updateCategoryList="updateCategoryList"
                :subCategoriesList="subCategoriesList"
                @updateSubCategoryList="updateSubCategoryList"
                :sectionsList="sectionsList"
                @updateSectionsList="updateSectionsList"
                :subSectionsList="subSectionsList"
                @updateSubSectionsList="updateSubSectionsList"></full-structure>
            <create-category v-else-if="selectedMenu == 'createCategory'"
                :categoriesList="categoriesList"
                @updateCategoryList="updateCategoryList"></create-category>
            <create-sub-category v-else-if="selectedMenu == 'createSubCategory'"
                :categoriesList="categoriesList"
                :subCategoriesList="subCategoriesList"
                @updateSubCategoryList="updateSubCategoryList"></create-sub-category>
            <create-section v-else-if="selectedMenu == 'createSection'"
                :categoriesList="categoriesList"
                :subCategoriesList="subCategoriesList"
                :sectionsList="sectionsList"
                @updateSectionsList="updateSectionsList"></create-section>
            <create-sub-section v-else-if="selectedMenu == 'createSubSection'"
                :categoriesList="categoriesList"
                :subCategoriesList="subCategoriesList"
                :sectionsList="sectionsList"
                :subSectionsList="subSectionsList"
                @updateSubSectionsList="updateSubSectionsList"></create-sub-section>
        </div>
    </div>
</template>

<script>
import createCategoryVue from './createCategory.vue';
import createSubcategoryVue from './createSubCategory.vue';
import createSectionVue from './createSection.vue';
import createSubSectionVue from './createSubSection.vue';
import fullStructureVue from './fullStructure.vue';

import sellLogixLoaderVue from '@/plugins/loaders/sellLogixLoader.vue';

export default {
    components: {
        createCategory: createCategoryVue,
        createSubCategory: createSubcategoryVue,
        createSection: createSectionVue,
        createSubSection: createSubSectionVue,
        fullStructure: fullStructureVue,

        sellLogixLoader: sellLogixLoaderVue,
    },
    data() {
        return {
            selectedMenu: 'fullStructure',
            categoriesLoaded: false,
            categoriesList: [],
            subCategoriesList: {},
            sectionsList: {},
            subSectionsList: {}
        }
    },
    methods: {
        setSelectedMenu(menu) {
            this.selectedMenu = menu;
        },
        updateCategoryList() {
            socket.emit('getAllCategories', (data) => {
                let editedCategoryData = data.map(category => {
                    return {
                        id: category.id,
                        name: category.name,
                        icon: category.icon,
                        photo_url: category.photo_url,
                        editing: false,
                        hidden: category.hidden === 1 ? true : false,
                    }
                })

                this.categoriesList = editedCategoryData;
                if (!this.categoriesLoaded) this.categoriesLoaded = true;
            })
        },
        updateSubCategoryList() {
            socket.emit('getAllSubCategories', (data) => {
                for (const key in data) {
                    let thisCategory_subCategories = data[key].map(subCategory => {
                        return {
                            id: subCategory.id,
                            category_id: subCategory.category_id,
                            name: subCategory.name,
                            icon: subCategory.icon,
                            photo_url: subCategory.photo_url,
                            editing: false,
                            hidden: subCategory.hidden === 1 ? true : false,
                        }
                    })

                    if (this.subCategoriesList.hasOwnProperty(key)) {
                        data[key] = {
                            opened: this.subCategoriesList[key].opened,
                            data: thisCategory_subCategories
                        }
                    } else {
                        data[key] = {
                            opened: false,
                            data: thisCategory_subCategories
                        }
                    }
                    
                }

                this.subCategoriesList = data;
            })
        },
        updateSectionsList() {
            socket.emit('getAllSections', (data) => {
                for (const key in data) {
                    let thisSubCategory_sections = data[key].map(section => {
                        return {
                            id: section.id,
                            subcategory_id: section.subcategory_id,
                            name: section.name,
                            icon: section.icon,
                            photo_url: section.photo_url,
                            editing: false,
                            hidden: section.hidden === 1 ? true : false,
                        }
                    })

                    if (this.sectionsList.hasOwnProperty(key)) {
                        data[key] = {
                            opened: this.sectionsList[key].opened,
                            data: thisSubCategory_sections
                        }
                    } else {
                        data[key] = {
                            opened: false,
                            data: thisSubCategory_sections
                        }
                    }
                    
                }

                this.sectionsList = data;
            })
        },
        updateSubSectionsList() {
            socket.emit('getAllSubSections', (data) => {
                for (const key in data) {
                    let thisSections_subSections = data[key].map(subSection => {
                        return {
                            id: subSection.id,
                            section_id: subSection.section_id,
                            name: subSection.name,
                            icon: subSection.icon,
                            photo_url: subSection.photo_url,
                            editing: false,
                            hidden: subSection.hidden === 1 ? true : false,
                        }
                    })

                    if (this.subSectionsList.hasOwnProperty(key)) {
                        data[key] = {
                            opened: this.subSectionsList[key].opened,
                            data: thisSections_subSections
                        }
                    } else {
                        data[key] = {
                            opened: false,
                            data: thisSections_subSections
                        }
                    }
                    
                }

                this.subSectionsList = data;
            })
        }
    },
    mounted() {
        // this.updateCategoryList();
        // this.updateSubCategoryList();
        // this.updateSectionsList();
        // this.updateSubSectionsList();
    },
    activated() { // For keep-alive
        this.updateCategoryList();
        this.updateSubCategoryList();
        this.updateSectionsList();
        this.updateSubSectionsList();
    }
}
</script>

<style>

</style>